<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawerRight"
      fixed
      right
      clipped
      app
    >
      <v-container v-if="images.length > 0">
        <v-textarea
          label="Текст"
          v-model="images[activeImage].text"
          rows="2"
          hint="Введите текст для нанесения на изображение"
        ></v-textarea>
        <v-select
          :items="fonts"
          v-model="images[activeImage].font"
          box
          label="Шрифт"
        ></v-select>
        <v-slider
          v-model="images[activeImage].size"
          thumb-label="always"
          label="Размер"
          min="10"
          max="330"
        ></v-slider>
        <v-slider
          v-model="images[activeImage].angle"
          thumb-label="always"
          label="Поворот"
          min="0"
          max="360"
        ></v-slider>
        <verte display="widget" picker="square" model="rgb" v-model="images[activeImage].color"></verte>
      </v-container>
    </v-navigation-drawer>
    <v-toolbar
      color="primary"
      dark
      fixed
      app
      clipped-right
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>
        <h1>Водяной знак</h1>
      </v-toolbar-title>
      <v-flex>
        <v-progress-circular
          v-if="showLoader"
          indeterminate
          color="white"
        ></v-progress-circular>
        <div v-if="!showLoader" class="progress-placeholder"></div>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex offset-xs1 caption font-weight-light hidden-xs-only>Расскажите друзьям: <div class="ya-share2" data-services="vkontakte,facebook,odnoklassniki,moimir,gplus" data-counter=""></div></v-flex>
      <v-toolbar-side-icon @click.stop="drawerRight = !drawerRight"></v-toolbar-side-icon>
    </v-toolbar>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      app
    >
      <v-container><file-upload :caption="'Загрузить фото'" :color="'error'" v-on:files-uploaded="prepareImages($event)"></file-upload></v-container>
      <v-list dense>
        <v-list-tile v-for="(value, index) in images" :key="index">
          <v-list-tile-content>
            <v-list-tile-title><a href="#" v-on:click.prevent="selectImage(index)">{{ value.name }}</a></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action @click.stop="removeImage(index)">
            <v-icon>close</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>
      <v-spacer></v-spacer>
      <div class="flex caption font-weight-light offset-xs1 mt-4">
        <a href="#" @click.stop="dialogFeedback = true">Отзывы и предложения</a><br>
        Сервис создания водяных знаков &copy; 2019
      </div>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="left"
      temporary
      fixed
    ></v-navigation-drawer>
    <v-content>
      <v-container v-if="images.length == 0" class="text-xs-center"><file-upload :caption="'Загрузите фото'" v-on:files-uploaded="prepareImages($event)"></file-upload></v-container>
      <v-container class="workarea" v-show="images.length > 0">
        <img v-if="images.length > 0" ref="image" :src="images[activeImage].path" :alt="images[activeImage].name" :label="images[activeImage].name">
        <img class="text-layer" style="top: 200px; left: 200px;" ref="text" :src="texts[activeImage]" alt="">
      </v-container>
    </v-content>
    <v-navigation-drawer
      v-model="right"
      right
      temporary
      fixed
    ></v-navigation-drawer>
    <v-fab-transition
      v-if="images.length > 0">
      <v-btn
        color="error"
        dark
        fab
        fixed
        bottom
        left
        @click.stop="dialog = true; prepareResult();"
      >
        <v-icon>cloud_download</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-dialog
      v-model="dialog"
      max-width="290"
    >
      <v-card>
        <v-card-title v-show="showLoader" class="headline">Пожалуйста, подождите</v-card-title>

        <v-card-text class="text-xs-center">
          <v-progress-circular
            v-if="showLoader"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <a
            v-if="!showLoader"
            :href="resultPath"
            target="_blank"
            class="v-btn v-btn--large theme--dark blue"><div class="v-btn__content">Скачать</div></a>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary darken-1"
            flat="flat"
            @click="dialog = false"
            v-if="!showLoader"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
     <v-dialog
      v-model="dialogFeedback"
    >
      <v-card>
        <v-card-title class="headline">Отзывы и предложения</v-card-title>

        <v-card-text>
          <vk-comments></vk-comments>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="primary darken-1"
            flat="flat"
            @click="dialogFeedback = false"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import FileUpload from './components/FileUpload'
import VkComments from './components/VkComments'
import Verte from 'verte';
import {mapState} from 'vuex';
import _ from 'lodash';

export default {
  name: 'App',
  components: {
    FileUpload,
    VkComments,
    Verte,
  },
  data: () => ({
    drawer: null,
    drawerRight: null,
    right: false,
    left: false,
    activeImage: -1,
    images: [],
    texts: [],
    fonts: [],
    dialog: false,
    dialogFeedback: false,
    resultPath: '',
  }),
  props: {
    source: String
  },
  computed: {
      ...mapState({
          api_url: state => state.api_url,
          showLoader: state => state.showLoader,
      }),
  },
  watch: {
    images: {
      handler: function(newVal) {
        this.debouncedUpdateText(newVal);
      },
      deep: true,
    },
    activeImage: function() {
      if(this.images.length > 0) {
        this.dragElement(this.$refs.text);
      }
    },
  },
  methods: {
    prepareImages(files) {
      var i;        
      for (i = 0; i < files.length; i++) {
        this.images.push({
          'name': files[i].name,
          'path': files[i].path,
          'width': files[i].width,
          'text': '',
          'font': this.fonts[0],
          'size': 50,
          'angle': 360,
          'color': '#000000',
        });
        this.texts.push('');
      }
      this.activeImage = this.images.length - 1;
    },
    removeImage(index) {
      this.images.splice(index, 1);
      this.texts.splice(index, 1);
    },
    selectImage(index) {
      this.activeImage = index;
    },
    updateText(images) {
      this.$http.post(this.api_url + 'text/', {
        text: this.images[this.activeImage].text,
        font: this.images[this.activeImage].font,
        size: this.images[this.activeImage].size,
        angle: this.images[this.activeImage].angle,
        bg: this.images[this.activeImage].path,
        bg_width: this.$refs.image.clientWidth,
        color: this.images[this.activeImage].color}).then(result => {
          this.$set(this.texts, this.activeImage, result.body.path);
          this.$refs.text.style.width = result.body.width + 'px';
      });
    },
    prepareResult() {
      this.$http.post(this.api_url + 'export', {
        text: this.texts[this.activeImage],
        x: this.$refs.text.style.left,
        y: this.$refs.text.style.top,
        bg: this.images[this.activeImage].path,
        bg_width: this.$refs.image.clientWidth
        }).then(result => {
          this.resultPath = result.body.path;
      });
    },
    dragElement(elmnt) {
      var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
      elmnt.onmousedown = dragMouseDown;

      function dragMouseDown(e) {
        e = e || window.event;
        e.preventDefault();
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }

      function elementDrag(e) {
        e = e || window.event;
        e.preventDefault();
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
      }

      function closeDragElement() {
        // stop moving when mouse button is released:
        document.onmouseup = null;
        document.onmousemove = null;
      }
    },
  },
  mounted() {
    this.$http.get(this.api_url + 'fonts/', {}).then(result => {
      this.fonts = result.body;
    });

    let yashareScript = document.createElement('script');
    yashareScript.setAttribute('src', '//yastatic.net/share2/share.js');
    document.head.appendChild(yashareScript);
  },
  created() {
    this.debouncedUpdateText = _.debounce(this.updateText, 300)
  },
}
</script>
<style>
  h1 {
    font-size: 20px;
    font-weight: 500;
    letter-spacing: 0.02em;
  }

  .progress-placeholder {
    width: 32px;
  }

  .v-list__tile__action i {
    cursor: pointer;
  }
  
  .workarea {
    position: relative;
  }

  .workarea img {
    max-width: 100%;
    height: auto;
  }

  .workarea .text-layer {
    position: absolute;
    cursor: grab;
  }
</style>
